import { TooltipProvider } from "@/components/ui/tooltip";
import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import { Toaster } from "sonner";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import AppLayout from "@/components/AppLayout";
import Dashboard from "@/pages/Dashboard";
import CalendarPage from "@/pages/Calendar";
import Bills from "@/pages/Bills";
import Debts from "@/pages/Debts";
import Simulator from "@/pages/Simulator";
import Guide from "@/pages/Guide";
import ResetPassword from "@/pages/ResetPassword";
import VerifyEmail from "@/pages/VerifyEmail";
import Settings from "@/pages/Settings";
import CashFlow from "@/pages/CashFlow";
import Admin from "@/pages/Admin";
import Join from "@/pages/Join";
import { ConfigProvider } from "@/context/ConfigContext";

function Protected({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <div className="min-h-screen flex items-center justify-center"><div className="h-10 w-10 rounded-full border-2 border-teal-500/30 border-t-teal-500 animate-spin" /></div>;
  if (!user) return <Navigate to="/login" replace state={{ from: location }} />;
  return <ConfigProvider><AppLayout>{children}</AppLayout></ConfigProvider>;
}

function AppRouter() {
  const location = useLocation();
  // Handle Emergent Auth callback synchronously if session_id fragment present
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/verify-email" element={<VerifyEmail />} />
      <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
      <Route path="/calendar" element={<Protected><CalendarPage /></Protected>} />
      <Route path="/bills" element={<Protected><Bills /></Protected>} />
      <Route path="/debts" element={<Protected><Debts /></Protected>} />
      <Route path="/simulator" element={<Protected><Simulator /></Protected>} />
      <Route path="/guide" element={<Protected><Guide /></Protected>} />
      <Route path="/settings" element={<Protected><Settings /></Protected>} />
      <Route path="/admin" element={<Protected><Admin /></Protected>} />
      <Route path="/household" element={<Navigate to="/settings" replace />} />
      <Route path="/cashflow" element={<Protected><CashFlow /></Protected>} />
      <Route path="/join/:code" element={<Join />} />
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <TooltipProvider>
        <AuthProvider>
          <AppRouter />
          <Toaster richColors position="top-right" />
        </AuthProvider>
        </TooltipProvider>
      </BrowserRouter>
    </ThemeProvider>
  );
}
